import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@learningblocks/shared-components';
import style from './style.module.scss';

const ENTER_KEY = 13;

/**
 * DownloadReportButton:
 *  - Displayed toward the bottom of content section of Last Notebook Section
 */
export function DownloadReportButton(props) {
  const className = `${style.btn} ${props.className}`;

  const onClick = (event) => {
    event.preventDefault();
    props.onClick();
  };

  const onKeyDown = (event) => event.keyCode === ENTER_KEY && props.onClick();

  return (
    <Button
      onKeyDown={onKeyDown}
      onClick={onClick}
      className={className}
      tabIndex={props.tabIndex}>
      End simulation
    </Button>
  );
}

DownloadReportButton.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Callback for Button click
   */
  onClick: PropTypes.func,
  /**
   * tabIndex to set on button
   */
  tabIndex: PropTypes.number,
};

DownloadReportButton.defaultProps = {
  className: '',
};
